import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';

import styles from './Tab.less';

const cxb = cx.bind(styles);

Tab.propTypes = {
  /** Style the tab as active */
  active: PropTypes.bool,
  /** The renderable badge value or element. */
  badge: PropTypes.node,
  /** The text label */
  label: PropTypes.string,
  /** use small styles */
  small: PropTypes.bool,
  /** The sub text label */
  subText: PropTypes.string,
  /** Callback function for the click event */
  onClick: PropTypes.func,
};

/**
 * **Not Accessable** This is an internal component.
 *
 * Renders the individual tab elements.
 *
 * @ignore
 * @private
 * @component Tab
 */
export default function Tab({ active, badge, className, label, subText, onClick, small }) {
  return (
    <button className={cx(className, cxb('tab', { active, badge, subText, small }))} onClick={onClick}>
      <span className={cxb('badge')}>
        <span>{badge}</span>
      </span>
      <span className={cxb('text')}>
        <Type className={cxb('label')}>{label || 'No Label'}</Type>
        <Type.SubText1 className={cxb('sub')}>{subText}</Type.SubText1>
      </span>
    </button>
  );
}
